export function StyledBooleanTrueSign() {
  return (
    <svg width='16' height='16' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M11.6673 3.5L5.25065 9.91667L2.33398 7' stroke='#0AAD50' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
